/* Cosmova – collection & search: AJAX filtering/sorting (Section Rendering API + history),
   dual price slider, active filter chips, grid density toggle, load more / infinite scroll. Requires theme.js. */
(function () {
  'use strict';
  var C = window.Cosmova; if (!C) return;
  var qs = C.qs, qsa = C.qsa, on = C.on;

  function gridKey() { return 'cosmova-grid-' + (window.innerWidth < 768 ? 'm' : 'd'); }
  function applyGrid(sec, cols) {
    var grid = qs('[data-product-grid]', sec), wrap = qs('[data-grid-toggle]', sec);
    if (!grid) return;
    grid.setAttribute('data-cols', cols);
    grid.style.setProperty(window.innerWidth < 768 ? '--cols-mobile' : '--cols', cols);
    if (wrap) qsa('button', wrap).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cols') === String(cols))); });
  }
  function initGridToggle(sec) {
    var wrap = qs('[data-grid-toggle]', sec); if (!wrap || wrap.dataset.ready) return; wrap.dataset.ready = '1';
    var saved = C.store(gridKey());
    if (saved) applyGrid(sec, saved);
    on(wrap, 'click', function (e) { var b = e.target.closest('[data-cols]'); if (!b) return; var c = b.getAttribute('data-cols'); applyGrid(sec, c); C.store(gridKey(), c); });
  }

  function initPriceRange(scope) {
    qsa('[data-price-range]', scope).forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var rMin = qs('[data-range-min]', box), rMax = qs('[data-range-max]', box), iMin = qs('[data-input-min]', box), iMax = qs('[data-input-max]', box);
      var max = parseFloat(rMax.max) || 100;
      function paint() { box.style.setProperty('--min', (rMin.value / max * 100) + '%'); box.style.setProperty('--max', (rMax.value / max * 100) + '%'); }
      on(rMin, 'input', function () { if (+rMin.value > +rMax.value - 1) rMin.value = +rMax.value - 1; iMin.value = +rMin.value > 0 ? rMin.value : ''; paint(); });
      on(rMax, 'input', function () { if (+rMax.value < +rMin.value + 1) rMax.value = +rMin.value + 1; iMax.value = +rMax.value < max ? rMax.value : ''; paint(); });
      on(rMin, 'change', function () { iMin.dispatchEvent(new Event('change', { bubbles: true })); });
      on(rMax, 'change', function () { iMax.dispatchEvent(new Event('change', { bubbles: true })); });
      on(iMin, 'input', function () { rMin.value = iMin.value || 0; paint(); });
      on(iMax, 'input', function () { rMax.value = iMax.value || max; paint(); });
      paint();
    });
  }

  function initFacets(sec) {
    var form = qs('[data-facets-form]'), drawer = qs('[data-facets-drawer]');
    if (!form || sec.dataset.facetsReady) return; sec.dataset.facetsReady = '1';
    var sectionId = C.sectionIdOf(sec), base = form.getAttribute('action'), controller;

    function queryFromForm() {
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      return params.toString();
    }
    function render(url, push) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      sec.classList.add('is-loading');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      return C.fetchText(fetchUrl, controller ? { signal: controller.signal } : undefined).then(function (html) {
        var doc = C.parseHTML(html);
        var swap = function (sel, scope) { var fresh = qs(sel, doc), cur = qs(sel, scope || sec); if (fresh && cur) cur.innerHTML = fresh.innerHTML; return cur; };
        var cols = (qs('[data-product-grid]', sec) || {}).getAttribute && qs('[data-product-grid]', sec).getAttribute('data-cols');
        swap('[data-collection-results]'); swap('[data-results-count]');
        // facets: keep accordions that the shopper opened
        var open = qsa('details[open]', form).map(function (d) { return d.id; });
        var freshForm = qs('[data-facets-form]', doc);
        if (freshForm) { form.innerHTML = freshForm.innerHTML; open.forEach(function (id) { var d = document.getElementById(id); if (d) d.open = true; }); }
        var freshFoot = qs('.facets__actions', doc), curFoot = drawer && qs('.facets__actions', drawer);
        if (freshFoot && curFoot) curFoot.innerHTML = freshFoot.innerHTML;
        if (cols) applyGrid(sec, cols);
        if (push) history.pushState({ facets: true }, '', url);
        initPriceRange(form); initLoadMore(sec); C.initScope(qs('[data-collection-results]', sec));
        var count = qs('[data-results-count]', sec); if (count) C.announce(count.textContent);
      }).catch(function (err) { if (err && err.name !== 'AbortError') window.location.href = url; })
        .then(function () { sec.classList.remove('is-loading'); });
    }
    var fromForm = C.debounce(function () { var q = queryFromForm(); render(base + (q ? '?' + q : ''), true); }, 350);
    on(form, 'change', function (e) { if (e.target.matches('[data-range-min], [data-range-max]')) return; fromForm(); });
    on(form, 'submit', function (e) { e.preventDefault(); fromForm(); });
    on(document, 'click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (!link || !document.contains(link)) return;
      e.preventDefault(); render(link.getAttribute('href'), true);
    });
    on(window, 'popstate', function () { render(window.location.pathname + window.location.search, false); });
  }

  function initLoadMore(sec) {
    var box = qs('[data-load-more]', sec); if (!box || box.dataset.ready) return; box.dataset.ready = '1';
    var link = qs('[data-load-more-link]', box); if (!link) return;
    var sectionId = C.sectionIdOf(sec), busy = false;
    function load() {
      if (busy) return; busy = true; link.classList.add('is-loading'); link.setAttribute('aria-busy', 'true');
      var url = link.getAttribute('href');
      C.fetchText(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId).then(function (html) {
        var doc = C.parseHTML(html), grid = qs('[data-product-grid]', sec), freshGrid = qs('[data-product-grid]', doc);
        var firstNew = null;
        if (grid && freshGrid) Array.prototype.slice.call(freshGrid.children).forEach(function (c) { var n = document.importNode(c, true); if (!firstNew) firstNew = n; grid.appendChild(n); });
        var freshBox = qs('[data-load-more]', doc);
        if (freshBox) { box.replaceWith(document.importNode(freshBox, true)); } else box.remove();
        C.initScope(grid);
        if (firstNew) { var f = qs('a', firstNew); if (f && box.contains(document.activeElement)) f.focus({ preventScroll: true }); }
        initLoadMore(sec);
      }).catch(function () { window.location.href = url; });
    }
    on(link, 'click', function (e) { e.preventDefault(); load(); });
    if (box.getAttribute('data-mode') === 'infinite' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px 0px' });
      io.observe(box);
    }
  }

  C.register(function (scope) {
    qsa('[data-collection]', scope).forEach(function (sec) { initGridToggle(sec); initFacets(sec); initLoadMore(sec); });
    initPriceRange(scope);
  });
})();
